import { gql } from '@apollo/client'

const UPDATE_USER_SETTINGS = gql`
  mutation updateUserSettings(
    $nonprofitOrgId: Int!
    $userIdToUpdate: Int
    $userSettingsInfo: UserSettingsUpdateInput!
    $responsibility: ResponsibilityInput
  ) {
    updateUserSettings(
      nonprofitOrgId: $nonprofitOrgId
      userIdToUpdate: $userIdToUpdate
      userSettingsInfo: $userSettingsInfo
      responsibility: $responsibility
    ) {
      id
    }
  }
`

export default UPDATE_USER_SETTINGS
